<template>
  <div id="app"
       v-bind:class="lightBG ? 'light' : 'dark'"
       v-bind:style="{'backgroundColor': backgroundColor, 'height': windowHeight + 'px'}">

    <div class="main"
         v-bind:style="{'height': windowHeight + 'px'}">

      <div class="logo" v-on:click="handleClick()"></div>

      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>

      <SelectedColor
        :backgroundColor="backgroundColor"
        v-if="currentRouteName === 'questions' || currentRouteName === 'landing' || currentRouteName === 'oneMoreThing'" />
    </div>
  </div>
</template>

<script>
import {lightOrDark} from './assets/data/lightOrDark'
import SelectedColor from './components/elements/SelectedColor.vue'

export default {
  name: 'App', 
  data() {
    return {
      windowHeight: 0,
      lightBG: true,
      lightOrDark: lightOrDark
    }
  },
  components: {SelectedColor},
  computed: {
    backgroundColor() {
      return this.$store.state.backgroundColor;
    },
    currentRouteName(){
      return this.$route.name
    }
  },
  created() { },
  mounted() {
    this.windowHeight = window.innerHeight //maximum height for mobile to avoid scrolling
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },

  watch: {
    backgroundColor(newValue) {
      this.lightBG = this.lightOrDark(newValue)
    }
  },
  methods: {
    handleClick() {
      window.open('https://www.britishpaints.com.au', "_blank")
    },  
    onResize() {
      this.windowHeight = window.innerHeight
    },
  }
}
</script>

<style lang="scss">
  @import "./assets/sass/main.scss";
</style>

